export const adCommentsConstants = {
    ACTIVATE_POLL_REQUEST: 'ACTIVATE_POLL_REQUEST',
    ACTIVATE_POLL_SUCCESS: 'ACTIVATE_POLL_SUCCESS',
    ACTIVATE_POLL_FAILURE: 'ACTIVATE_POLL_FAILURE'
};